import ServiceContainer from "@/containers/Service/ServiceContainer";

export default function service() {
  return <ServiceContainer isTossProcess={true} />;
}
